import React, { useState, useEffect } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const BALLOON_COLORS = [
    { color: '#ef4444', glow: 'rgba(239, 68, 68, 0.6)' },
    { color: '#3b82f6', glow: 'rgba(59, 130, 246, 0.6)' },
    { color: '#eab308', glow: 'rgba(234, 179, 8, 0.6)' },
    { color: '#22c55e', glow: 'rgba(34, 197, 94, 0.6)' },
    { color: '#a855f7', glow: 'rgba(168, 85, 247, 0.6)' },
    { color: '#ec4899', glow: 'rgba(236, 72, 153, 0.6)' },
];

const POP_CHEERS = ['POP! 🎈', 'HAPPY 2026! 🎉', 'CHEERS! 🥂', 'LEVEL UP! ⭐', 'VICTORY! 🍾'];

const InteractiveBalloons = () => {
    const [balloons, setBalloons] = useState([]);
    const [popEffects, setPopEffects] = useState([]);

    useEffect(() => {
        const initial = Array.from({ length: 16 }).map((_, i) => ({
            id: i,
            color: BALLOON_COLORS[i % BALLOON_COLORS.length],
            left: Math.random() * 92,
            delay: Math.random() * 6,
            duration: 8 + Math.random() * 6,
            scale: 0.8 + Math.random() * 0.4,
            popped: false
        }));
        setBalloons(initial);
    }, []);

    const handleBalloonClick = (b, e) => {
        e.stopPropagation();
        playThemeSound('newyear', 'balloonPop');

        const rect = e.currentTarget.getBoundingClientRect();
        const effectId = Date.now() + Math.random();
        const text = POP_CHEERS[Math.floor(Math.random() * POP_CHEERS.length)];

        setPopEffects(prev => [...prev, {
            id: effectId,
            x: rect.left,
            y: rect.top,
            text
        }]);

        setTimeout(() => {
            setPopEffects(prev => prev.filter(item => item.id !== effectId));
        }, 1100);

        setBalloons(prev => prev.map(item => {
            if (item.id === b.id) return { ...item, popped: true };
            return item;
        }));

        setTimeout(() => {
            setBalloons(prev => prev.map(item => {
                if (item.id === b.id) {
                    return {
                        ...item,
                        popped: false,
                        left: Math.random() * 92,
                        delay: 0,
                        duration: 8 + Math.random() * 6
                    };
                }
                return item;
            }));
        }, 3000);
    };

    return (
        <div className="fixed inset-0 pointer-events-none z-[61] overflow-hidden select-none">
            {/* Pop Cheer Floating text */}
            {popEffects.map((eff) => (
                <div
                    key={eff.id}
                    className="fixed text-sm md:text-base font-extrabold text-yellow-300 drop-shadow-[0_2px_8px_rgba(234,179,8,0.9)] animate-float-up pointer-events-none z-[75]"
                    style={{ left: eff.x, top: eff.y }}
                >
                    {eff.text}
                </div>
            ))}

            {/* Flying Balloons */}
            {balloons.map((b) => {
                if (b.popped) return null;
                return (
                    <div
                        key={b.id}
                        onClick={(e) => handleBalloonClick(b, e)}
                        onTouchStart={(e) => handleBalloonClick(b, e)}
                        className="absolute bottom-[-80px] animate-float-up pointer-events-auto cursor-pointer hover:scale-130 transition-transform"
                        style={{
                            left: `${b.left}%`,
                            animationDelay: `${b.delay}s`,
                            animationDuration: `${b.duration}s`,
                            transform: `scale(${b.scale})`,
                        }}
                        title="Click to pop the celebration balloon!"
                    >
                        <svg width="42" height="52" viewBox="0 0 40 50" style={{ overflow: 'visible', filter: `drop-shadow(0 4px 10px ${b.color.glow})` }}>
                            {/* Balloon String */}
                            <path d="M20 35 Q 20 45 25 55" stroke="rgba(255,255,255,0.7)" strokeWidth="1.2" fill="none" />
                            {/* Balloon Body */}
                            <ellipse cx="20" cy="20" rx="15" ry="18" fill={b.color.color} opacity="0.92" />
                            {/* Highlight */}
                            <ellipse cx="15" cy="15" rx="3" ry="5" fill="white" opacity="0.4" transform="rotate(-30 15 15)" />
                            {/* Balloon Knot */}
                            <polygon points="18,36 22,36 20,38" fill={b.color.color} />
                        </svg>
                    </div>
                );
            })}
        </div>
    );
};

export default InteractiveBalloons;
